import React from "react";
import styled from "styled-components";

export default function ProjectBox({ img, title, text, index }) {
  return (
    <Card>
      <ImageWrap><img src={img} alt={title} /><span>{String(index).padStart(2, "0")}</span></ImageWrap>
      <Content><h3>{title}</h3><p>{text}</p></Content>
    </Card>
  );
}

const Card = styled.article`height: 100%; overflow: hidden; border: 1px solid #e3e7e5; border-radius: 24px; background: #fff; transition: .3s ease; &:hover { transform: translateY(-6px); box-shadow: 0 22px 50px rgba(23,21,47,.1); }`;
const ImageWrap = styled.div`
  position: relative; height: 245px; overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; transition: transform .55s ease; }
  span { position: absolute; right: 16px; top: 16px; width: 40px; height: 40px; display: grid; place-items: center; border-radius: 50%; background: rgba(255,255,255,.9); color: #17152f; font-size: .67rem; font-weight: 800; backdrop-filter: blur(8px); }
  ${Card}:hover & img { transform: scale(1.045); }
`;
const Content = styled.div`padding: 25px 26px 29px; text-align: left; h3 { color: #17152f; font-size: 1.12rem; line-height: 1.3; } p { margin-top: 11px; color: #686d7b; font-size: .8rem; line-height: 1.7; }`;
